import { FC } from 'react';
import { Typography } from '@mui/material';
import { LoginOptionsAuditLog } from '@oxappsec/ox-unified-audit-logger';
import InfoItem from '../InfoItem';

const LoginOptions: FC<React.PropsWithChildren<LoginOptionsProps>> = ({
  auditLog,
}) => {
  return (
    <>
      <InfoItem
        name='Login Option'
        data={
          <Typography variant='body2' color='text.primary'>
            {auditLog.loginType}
          </Typography>
        }
      />
      {auditLog.domain ? (
        <InfoItem
          name='Domain'
          data={
            <Typography variant='body2' color='text.primary'>
              {auditLog.domain}
            </Typography>
          }
        />
      ) : null}
    </>
  );
};

export interface LoginOptionsProps {
  auditLog: LoginOptionsAuditLog;
}

export default LoginOptions;
